import React from 'react';

// Vertical connector rendered between two stop cards in the mobile route list.
// Shows travel distance + drive minutes + arrival time at the next stop.
//
// Hides itself when sequence === 1 (no rail above the first stop of the day —
// MyWork renders a separate "Depart base at HH:MM" header for that case).
//
// Props (all sourced from the *next* stop's fields per server contract):
//   travelMinutes  — integer minutes (stop.travel_minutes_in)
//   travelMiles    — decimal miles  (stop.travel_distance_miles)
//   arriveAt       — local "HH:MM" string (stop.start_time)
//   sequence       — stop's 1-indexed position; rail hides when sequence <= 1
//   compact        — when true, renders without the "Arrive ~HH:MM" subtitle
//                    (used in post-finish sheet preview)

const TravelRail = ({ travelMinutes, travelMiles, arriveAt, sequence, compact = false }) => {
  if (sequence != null && sequence <= 1) return null;
  if (travelMinutes == null && travelMiles == null) return null;

  const milesLabel =
    travelMiles == null ? null : `${Number(travelMiles).toFixed(travelMiles < 10 ? 1 : 0)} mi`;
  const minutesLabel = travelMinutes == null ? null : `${Math.round(travelMinutes)} min`;
  const primary = [milesLabel, minutesLabel].filter(Boolean).join(' · ');

  return (
    <div
      className="travel-rail"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '6px 0 6px 22px',
        position: 'relative',
        color: 'var(--color-text-secondary)',
        fontSize: 13,
      }}
    >
      <span
        aria-hidden="true"
        style={{
          position: 'absolute',
          left: 17,
          top: 0,
          bottom: 0,
          width: 2,
          background: 'var(--color-bg-inset)',
        }}
      />
      <i className="fa-sharp fa-regular fa-car" aria-hidden="true" />
      <span className="travel-rail__primary">{primary}</span>
      {!compact && arriveAt && (
        <span className="travel-rail__eta" style={{ marginLeft: 'auto', color: 'var(--color-text-secondary)' }}>
          Arrive ~{arriveAt}
        </span>
      )}
    </div>
  );
};

export default TravelRail;
